<div class="modal-header">
	<button type="button" class="close" data-dismiss="modal">×</button>
	<h4 class="modal-title">{{TR "Labels verwalten"}}</h4>
</div>
<div class="modal-body">
	{{#if canEditTags}}
		<div id="public-labels" class="m-t-5"></div>
		{{#if labels.selectable.tags}}
		    {{#if showTextLabelPool}}
    			<small>{{TR 'Verfügbare Labels (hinzufügen durch anklicken)'}}:</small>
		    {{else}}
                {{#if showTextTagsLabelPool}}
                    <small>{{TR 'Bereits Geräten zugewiesene und verfügbare Labels (hinzufügen durch anklicken)'}}:</small>
                {{else}}
                    <small>{{TR 'Bereits Geräten zugewiesene Labels (hinzufügen durch anklicken)'}}:</small>
                {{/if}}
			{{/if}}
			<br>
			{{#each labels.selectable.tags}}
			<a href="#" class="js-add-tag" data="{{this}}"><span class="label label-block label-tags">{{this}}</span></a>
			{{/each}}
		{{/if}}
	{{/if}}

	<div id="privat-labels" class="m-t-15"></div>
	{{#if labels.selectable.groups}}
		<small>{{TR 'Bereits Geräten zugewiesene Labels (hinzufügen durch anklicken)'}}:</small>
		<br>
		{{#each labels.selectable.groups}}
		<a href="#" class="js-add-group" data="{{this}}"><span class="label label-block label-groups">{{this}}</span></a>
		{{/each}}
	{{/if}}
</div>
<div class="modal-footer">
	<button id="ct-cancel" type="button" class="btn btn-white" data-dismiss="modal">{{TR "Abbrechen"}}</button>
	<button class="btn btn-primary" id="js-success">{{TR "Speichern"}}</button>
</div>
